export default __webpack_public_path__ + "static/media/final.f7615f20.mp3";